import * as tslib_1 from "tslib";
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserSettingsHttpService } from '../user-settings';
import * as i0 from "@angular/core";
import * as i1 from "../user-settings/_services/user-settings-http.service";
var FilterOptionsService = /** @class */ (function () {
    function FilterOptionsService(userSettingsHttp) {
        this.userSettingsHttp = userSettingsHttp;
    }
    /**
     * Load distributors based on user role
     */
    FilterOptionsService.prototype.loadDistributors = function (role, includeAll) {
        if (includeAll === void 0) { includeAll = false; }
        if (role !== 'sadmin') {
            return of([]);
        }
        return this.userSettingsHttp.getDistis().pipe(map(function (distis) {
            var options = distis.map(function (d) { return (tslib_1.__assign({ value: d.disti_id, label: d.name }, d)); });
            if (includeAll && options.length > 0) {
                options.unshift({ value: null, label: 'All' });
            }
            return options;
        }));
    };
    /**
     * Normalize ID parameter to comma-separated string for API
     */
    FilterOptionsService.prototype.normalizeIdParam = function (id) {
        if (!id) {
            return null;
        }
        if (Array.isArray(id)) {
            if (id.length === 0) {
                return null;
            }
            return id.map(function (i) { return String(i); }).join(',');
        }
        return String(id);
    };
    /**
     * Load markets for a given distributor(s)
     */
    FilterOptionsService.prototype.loadMarkets = function (distributorId, includeAll) {
        if (includeAll === void 0) { includeAll = false; }
        var normalizedId = this.normalizeIdParam(distributorId);
        if (!normalizedId) {
            return of([]);
        }
        return this.userSettingsHttp.getMarkets({ disti_id: normalizedId }).pipe(map(function (markets) {
            var options = markets.map(function (m) { return (tslib_1.__assign({ value: m.market_id, label: m.market_name }, m)); });
            if (includeAll && options.length > 0) {
                options.unshift({ value: null, label: 'All' });
            }
            return options;
        }));
    };
    /**
     * Load clients for given distributor(s) and/or market(s)
     */
    FilterOptionsService.prototype.loadClients = function (distributorId, marketId, includeAll, retailOnly, retailEquipment) {
        if (includeAll === void 0) { includeAll = false; }
        if (retailOnly === void 0) { retailOnly = false; }
        if (retailEquipment === void 0) { retailEquipment = false; }
        var params = {};
        var normalizedDistiId = this.normalizeIdParam(distributorId);
        if (normalizedDistiId) {
            params.disti_id = normalizedDistiId;
        }
        var normalizedMarketId = this.normalizeIdParam(marketId);
        if (normalizedMarketId) {
            params.market_id = normalizedMarketId;
        }
        if (retailOnly) {
            params.retail_only = '1';
        }
        if (retailEquipment) {
            params.retail_equipment = '1';
        }
        return this.userSettingsHttp.getClients(params).pipe(map(function (clients) {
            var options = clients.map(function (c) { return (tslib_1.__assign({ value: c.client_id, label: c.company_name }, c)); });
            if (includeAll && options.length > 0) {
                options.unshift({ value: null, label: 'All' });
            }
            return options;
        }));
    };
    /**
     * Load campuses for given client(s), distributor(s), and/or market(s)
     */
    FilterOptionsService.prototype.loadCampuses = function (clientId, distributorId, marketId, includeAll, retailOnly, retailEquipment) {
        if (includeAll === void 0) { includeAll = false; }
        if (retailOnly === void 0) { retailOnly = false; }
        if (retailEquipment === void 0) { retailEquipment = false; }
        var params = {};
        var normalizedClientId = this.normalizeIdParam(clientId);
        if (normalizedClientId) {
            params.client_id = normalizedClientId;
        }
        var normalizedDistiId = this.normalizeIdParam(distributorId);
        if (normalizedDistiId) {
            params.disti_id = normalizedDistiId;
        }
        var normalizedMarketId = this.normalizeIdParam(marketId);
        if (normalizedMarketId) {
            params.market_id = normalizedMarketId;
        }
        if (retailOnly) {
            params.retail_only = '1';
        }
        if (retailEquipment) {
            params.retail_equipment = '1';
        }
        return this.userSettingsHttp.getCampus(params).pipe(map(function (campuses) {
            var options = campuses.map(function (c) { return (tslib_1.__assign({ value: c.campus_id, label: c.name }, c)); });
            if (includeAll && options.length > 0) {
                options.unshift({ value: null, label: 'All' });
            }
            return options;
        }));
    };
    /**
     * Load machines for given campus(es), client(s), distributor(s), and/or market(s)
     */
    FilterOptionsService.prototype.loadMachines = function (campusId, clientId, distributorId, marketId, includeAll, retailEquipment) {
        if (includeAll === void 0) { includeAll = false; }
        if (retailEquipment === void 0) { retailEquipment = false; }
        var params = {};
        if (retailEquipment) {
            params.retail_equipment = '1';
        }
        var normalizedCampusId = this.normalizeIdParam(campusId);
        if (normalizedCampusId) {
            params.campus_id = normalizedCampusId;
        }
        var normalizedClientId = this.normalizeIdParam(clientId);
        if (normalizedClientId) {
            params.client_id = normalizedClientId;
        }
        var normalizedDistiId = this.normalizeIdParam(distributorId);
        if (normalizedDistiId) {
            params.disti_id = normalizedDistiId;
        }
        var normalizedMarketId = this.normalizeIdParam(marketId);
        if (normalizedMarketId) {
            params.market_id = normalizedMarketId;
        }
        return this.userSettingsHttp.getMachines(params).pipe(map(function (machines) {
            var options = (machines || []).map(function (m) { return (tslib_1.__assign({ value: m.machine_id, label: m.machine_name || m.serial_no || m.machine_id }, m)); });
            if (includeAll && options.length > 0) {
                options.unshift({ value: null, label: 'All' });
            }
            return options;
        }));
    };
    FilterOptionsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FilterOptionsService_Factory() { return new FilterOptionsService(i0.ɵɵinject(i1.UserSettingsHttpService)); }, token: FilterOptionsService, providedIn: "root" });
    return FilterOptionsService;
}());
export { FilterOptionsService };
